import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/utils/storage'
import DictApi from '@/services/dict'

Vue.use(Vuex)


const types = {
  SET_COUNTRY_CODE: 'SET_COUNTRY_CODE',
}
export default new Vuex.Store({
  getters: {
    isPC: state => state.isPC,
    isMobile: state => state.isMobile,
    isLandscape: state => state.isLandscape,
    workCountryData: state => state.workCountryData,
  },
  state: {
    isPC: true,
    isMobile: false,
    isLandscape: false,
    workCountryData: [],
  },
  actions: {
    setPlatform ({ commit }, isPC) {
    },
    setMobile ({ commit }, isMobile) {
    },
    setOrientation ({ commit }, isLandscape) {
    },
    loadCountry ({ commit }, payload) {
      DictApi.getCountryCode(payload).then(res => {
        if (res.ok) {
          commit(types.SET_COUNTRY_CODE, {
            data: res.data,
            status: payload.cooperation_status
          })
        }
      })
    }
  },
  mutations: {
    SET_MOBILE (state, isMobile) {
      // state.isMobile = isMobile
    },
    SET_PLATFORM (state, isPC) {
      // state.isPC = isPC
      // state.isMobile = !isPC
    },
    SET_ORIENTATION (state, isLandscape) {
      // state.isLandscape = isLandscape
    },
    [types.SET_COUNTRY_CODE] (state, { data, status }) {
      state.workCountryData = data
      const obj = data.find(item => {
        return item.opt_status === 1
      })
      state.defaultWorkCountry = obj.id
      storage.setItem('defaultWorkCountry', obj.id)
    }
  }
})
